// extracted by mini-css-extract-plugin
module.exports =  {"title":"title__j-WzZ"};